"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BezierCurve_1 = require("./BezierCurve");
const pointsToBezierCurves_1 = require("./helpers/pointsToBezierCurves");
class BezierInterpolation {
    /**
     * Interpolate a list of points to a list of ordered Bezier curve segments
     * @param {Array<Point>} workPoints Points to interpolate
     * @param {boolean} isClosedCurve True if is a closed curve
     * @param {number} smoothValue Optional value for making the curve smoother or not
     * @returns {BezierCurve} The bezier curve
     */
    static pointsToBezierCurves(points, isClosedCurve, smoothValue = 0.8) {
        return new BezierCurve_1.default((0, pointsToBezierCurves_1.default)(points, isClosedCurve, smoothValue));
    }
}
exports.default = BezierInterpolation;
//# sourceMappingURL=BezierInterpolation.js.map